import { render, staticRenderFns } from "./CustomerEditTabAccount.vue?vue&type=template&id=899ae8ee&scoped=true&"
import script from "./CustomerEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditTabAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerEditTabAccount.vue?vue&type=style&index=1&id=899ae8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ae8ee",
  null
  
)

export default component.exports